var exports = {
  "kL": "x936d19a0--8edb12--container",
  "ZF": "x936d19a0--8edb12--answer",
  "h_": "x936d19a0--8edb12--description",
  "qr": "x936d19a0--8edb12--footer",
  "z3": "x936d19a0--8edb12--error",
};

module.exports = exports;
